import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import salonReducer from "./slices/salonSlice";
import staffReducer from "./slices/staffSlice";
import customerReducer from "./slices/customerSlice";
import serviceReducer from "./slices/serviceSlice";
import payrollReducer from "./slices/payrollSlice";
import inventoryReducer from "./slices/inventorySlice";
import financeReducer from "./slices/financeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    salon: salonReducer,
    staff: staffReducer,
    customers: customerReducer,
    services: serviceReducer,
    payroll: payrollReducer,
    inventory: inventoryReducer,
    finance: financeReducer,
  },
});
